<template>
    <div class="oauth-callback">
        <div v-if="loading">
            <p>驗證中，請稍候...</p>
        </div>
        <div v-else-if="error" style="color: red;">
            <p>發生錯誤：{{ error }}</p>
            <p>將在 {{ countdown }} 秒後返回登入頁面</p>
        </div>
    </div>
  </template>
  
  <script>
  import OAuthService from '../api/oauth';
  export default {
    name: 'OAuthCallback',
    data() {
        return {
            loading: true,
            error: null,
            countdown: 5
        }
    },
    async created() {
      try {
        // 從URL獲取授權碼
        const code = this.$route.query.code
        if (!code) {
          throw new Error('No authorization code provided')
        }
  
        // 取得access token
        const accessToken = await OAuthService.getAccessToken(code, window.location.origin+'/#/oauthCallback');
        this.$store.dispatch('setHasIcivicLogin', true);
        this.loading = false;
  
        // 重定向到登入頁面
        this.$router.push('/login');
      } catch (error) {
        console.error('OAuth callback error:', error);
        this.error = error.message;
        this.loading = false;
        // 可以延遲一段時間後再重定向
        const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                clearInterval(timer);
                window.location.href = foxdrive_api.getIcivicAuthorizeUrl();
            }
        }, 1000);
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// OAuthCallback.vue?42e360be